import React, { useRef, useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import styled from 'styled-components';
import { Col, Row, Text } from '../../style/base.style';
import { Colors } from '../../style/colors';
import "primeicons/primeicons.css";

export interface UploadFieldTypeProps {
  fieldConfig: FieldConfig;
  onFieldChange: (name: string, value: any) => void;
}

interface UploadFieldOptions {
  download?: (url: string,fileName:string) => void;
}

interface DefaultValue {
  name: string;
  size: number;
  url: string;
}

export const UploadField = ({ fieldConfig, onFieldChange }: UploadFieldTypeProps) => {
  const toast = useRef<Toast>(null);
  const fileUploadRef = useRef<FileUpload>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const {defaultValue} = fieldConfig;  
  const [totalSize, setTotalSize] = useState(0);

  const { download } = fieldConfig.typeOptions as UploadFieldOptions || {};

console.log(defaultValue, "defaultValue!!")


  useEffect(() => {
    const size = selectedFiles.reduce((acc, f: any) => acc + (f.size || 0), 0);
    setTotalSize(size);
  }, [ selectedFiles]);

  const handleClick = () => {
    const fileUploadEl = fileUploadRef.current as any;
    const fileInput = fileUploadEl?.getInput?.() || fileUploadEl?.el?.querySelector('input[type="file"]');
    fileInput?.click();
  };

  const onTemplateSelect = (e: any) => {
    const newFiles: File[] = Array.from(e.files || []);
   
    setSelectedFiles(newFiles);


    const _totalSize = newFiles.reduce((acc, file: any) => acc + (file.size || 0), 0);
    setTotalSize(_totalSize);
    onFieldChange(fieldConfig.name, newFiles);
  };

  const onTemplateUpload = () => {
    const _totalSize = selectedFiles.reduce((acc, file: any) => acc + (file.size || 0), 0);
    setTotalSize(_totalSize);
    toast.current?.show({ severity: 'info', summary: 'Success', detail: 'File(s) Uploaded' });
  };

  const onTemplateRemove = (file: File, callback: () => void) => {
    const updatedFiles = selectedFiles.filter((f) => f.name !== file.name);
    setSelectedFiles(updatedFiles);


    const _totalSize = updatedFiles.reduce((acc, f: any) => acc + (f.size || 0), 0);
    setTotalSize(_totalSize);
    onFieldChange(fieldConfig.name, updatedFiles);
    callback();
  };

  const onTemplateClear = () => {
    setSelectedFiles([]);
    setTotalSize(selectedFiles.reduce((acc, f: any) => acc + (f.size || 0), 0));
    onFieldChange(fieldConfig.name, selectedFiles);
  };



  const limitedName = (name = '') =>
    name.length > 30 ? name.substring(0, 30) + '...' : name;

  const fileIcons: Record<string, string> = {
    docx: 'pi-file-word',
    pdf: 'pi-file-pdf',
    xlsx: 'pi-file-excel',
    pptx: 'pi-file-powerpoint',
    zip: 'pi-file-archive',
    rar: 'pi-file-archive',
    csv: 'pi-file-excel',
    doc: 'pi-file-word',
    xls: 'pi-file-excel',
    ppt: 'pi-file-powerpoint',
  };

  const itemTemplate = (file: any, props: any) => {
    const fileName = file.name;
    const ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    const fileIsImage = ['jpg', 'jpeg', 'png', 'gif'].includes(ext);

    return (
      <Row style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white', borderRadius: '10px', padding: '5px', fontSize: '12px', gap: '10px' }}>
        <Row $width="80%" $justifyContent="flex-start" $gap={10}>
        <Col $maxWidth="20px" $margin="0 10px 0 0" $padding="0 5px">
          {fileIsImage ? (
            <img alt={file.name} role="presentation" src={file.objectURL} width="20px" />
          ) : (
            <i className={`pi ${fileIcons[ext] || 'pi-file'} text-2xl`} />
          )}
        </Col>
        <Col>
          <Row $justifyContent='flex-start'><Text $margin="0" $fontSize="13px">{limitedName(file.name)}</Text></Row>
          <Row $justifyContent='flex-start'><Text $margin="0" $fontSize="13px">{props.formatSize}</Text></Row>
        </Col>
        </Row>
        
        <Button
          size="small"
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </Row>
    );
  };

  const defaultFileTemplate = (file: DefaultValue) => {
    const ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
    const fileIsImage = ['jpg', 'jpeg', 'png', 'gif'].includes(ext);

    return (
      <Row style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white', borderRadius: '10px', padding: '5px', fontSize: '12px', gap: '10px' }}>
         <Row $width="70%" $justifyContent="flex-start" $gap={10}>
         <Col $maxWidth="20px" $margin="0 10px 0 0" $padding="0 5px">
          {fileIsImage ? (
            <img alt={file.name} role="presentation" src={file.url} width="20px" />
          ) : (
            <i className={`pi ${fileIcons[ext] || 'pi-file'} text-2xl`} />
          )}
        </Col>
        <Col>
          <Row $justifyContent='flex-start'> <Text $margin="0" $fontSize="13px">{limitedName(file.name)}</Text></Row>
          <Row $justifyContent='flex-start'><Text $margin="0" $fontSize="13px">{Math.round(file.size / 1024)} KB</Text></Row>
          
        </Col>
         </Row>
        
        
        <Button
            size="small"
            type="button"
            icon="pi pi-download"
            className="p-button-outlined p-button-rounded"
            onClick={() => download?.(file.url,file.name)}
          />
          
      </Row>
    );
  };

  const EmptyTemplate = (options: any) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    
    return (
      <EmptyTemplateContainer className="file-upload-empty" onClick={handleClick}>
      Drag and drop files here to upload
    </EmptyTemplateContainer>
    )
    
  }

  const additionalClass = totalSize ? '' : ' hide';
  const chooseOptions = { icon: 'pi pi-fw pi-file', iconOnly: true, className: 'upload-icon choose custom-choose-btn' };
  const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: `upload-icon upload hide custom-upload-btn` };
  const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: `upload-icon clear${additionalClass} custom-cancel-btn` };

  return (
    <FieldContainer>
      <Toast ref={toast} />

      <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
      <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
      <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

      {defaultValue.map(defaultFileTemplate)}

      <FileUpload
        ref={fileUploadRef}
        name="demo[]"
        multiple
        maxFileSize={1000000}
        onUpload={onTemplateUpload}
        onSelect={onTemplateSelect}
        onError={onTemplateClear}
        onClear={onTemplateClear}
        itemTemplate={itemTemplate}
        emptyTemplate={EmptyTemplate}
        chooseOptions={chooseOptions}
        cancelOptions={cancelOptions}
        uploadOptions={uploadOptions}
        
      />
    </FieldContainer>
  );
};



  

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid ${Colors.fieldBorder};
  box-sizing: border-box;
`;

const EmptyTemplateContainer = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.fieldBorder};
  border-radius: 5px;
`;
